<template>
  <div>
    <home-carousel></home-carousel>
    <about-us></about-us>
    <service-card></service-card>
    <call-us></call-us>
  </div>
</template>

<script>
// @ is an alias to /src
import HomeCarousel from "@/components/HomeCarousel.vue";
import AboutUsInfo from "@/components/AboutUsInfo.vue";
import ServiceCard from "@/components/ServiceCard.vue";
import CallUs from "@/components/CallUs.vue";

export default {
  created() {
    document.title = "Home";
  },
  name: "Home",
  components: {
    "home-carousel": HomeCarousel,
    "about-us": AboutUsInfo,
    "call-us": CallUs,
    "service-card": ServiceCard
  }
};
</script>
<style scoped></style>
